import React from "react";
import {
  Category,
  GridView,
  PaymentOutlined,
  Person,
  PriceCheck,
  RealEstateAgentOutlined,
  Receipt,
  School,
  ShoppingCart,
  Store,
  StoreOutlined,
  Settings
} from "@mui/icons-material";

export const SIDEBAR_ICONS = {
  grid: <GridView />,
  shoppingCart: <ShoppingCart />,
  category: <Category />,
  orders: <RealEstateAgentOutlined />,
  priceCheck: <PriceCheck />,
  paymentOutlined: <PaymentOutlined />,
  receipt: <Receipt />,
  person: <Person />,
  school: <School />,
  store: <Store />,
  storeOutlined: <StoreOutlined />,
  settings: <Settings />
} as const;

export type SidebarIconKey = keyof typeof SIDEBAR_ICONS;
